<template>
  <section id="home">
    <v-parallax dark src="@/assets/img/bgHero.jpg" height="750">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8">
              <h1 class="display-2 font-weight-bold mb-4">
                浙江星寰科技有限公司
              </h1>
              <h1 class="font-weight-light">商务合作热线：<span>0574-87612060</span></h1>
              <v-btn
                rounded
                outlined
                large
                dark
                @click="$vuetify.goTo('#features')"
                class="mt-5"
              >
                了解更多
                
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down"> </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container fluid id="features" class="mt-2">
      <v-row align="center" justify="center">
        <v-col cols="40">
          <v-row align="center" justify="space-around">
            <v-col cols="10" class="text-center">
              <div class="text-padding">
                <h2 class="font-weight-light:999 display-1 ">
                  关于我们</h2>
                </div>

              <h1 class="font-weight-light display-1 custom-text-color" >About</h1>
              <h4 class="custom-text-color2">
                浙江星寰科技有限公司是一家专业从事数字化定制解决方案、系统集成、智慧港口和电子政务开发与应用的高新技术企业。依托自主研发的核心技术，优质高效的服务体系，以及度身定制的行业解决方案，致力于为国内港口码头系统、江浙沪地区的企事业单位等提供数字化咨询、技术实施及运营服务。
              </h4>
              <h4 class="custom-text-color2">
                公司致力开发以“智慧港口、数智招商、城市治理一网统管、智慧人力资源、政务信息快响协同”等为代表的特色自主研发产品。是国家高新技术企业、宁波市信息科技工程（技术）中心，CSEE、CSIA宁波软件企业，宁波软件协会会员单位，获得ISO9001计算机信息系统集成、计算机应用软件开发及其服务、质量管理体系认证资质等。
              </h4>
              <h4 class="custom-text-color2">
                公司以定制化开发为特色，凭借领先的技术优势和深厚的行业积累，坚持高质量发展，拥抱创新，开发“真正属于您的数字化整体解决方案”“您与未来，只有‘星寰智联<sup>®️</sup>’的距离”。
              </h4>
            </v-col>
            <!-- 多卡片 -->

            <!-- <v-col
              cols="12"
              sm="4"
              class="text-center"
              v-for="(feature, i) in features"
              :key="i"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="card"
                  shaped
                  :elevation="hover ? 10 : 4"
                  :class="{ up: hover }"
                >
                  <v-img
                    :src="feature.img"
                    max-width="100px"
                    class="d-block ml-auto mr-auto"
                    :class="{ 'zoom-efect': hover }"
                  ></v-img>
                  <h1 class="font-weight-regular">{{ feature.title }}</h1>
                  <h4 class="font-weight-regular subtitle-1">
                    {{ feature.text }}
                  </h4>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      videoId: "i8IvvHJssWE",
      features: [
        {
          // img: require("@/assets/img/icon2.png"),
          title: "Clean Design",
          text: "浙江星寰科技有限公司是一家专业从事电子政务开发与应用、港口码头智能系统和管理软件开发的国家高新技术企业。公司依托自主研发的的核心技术，优质高效的服务体系，以及度身定制的行业解决方案，致力于为国内港口码头系统，政府机关、企事业单位等提供各类信息技术服务。",
        },
      ],
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
};
</script>

<style lang="scss">
.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;

  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
</style>

<style scope>
.text-padding{
  padding-top: 50px ;
}
.btn-play {
  transition: 0.2s;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}

.custom-text-color{
  color:rgb(51, 106, 206) !important;
  padding-bottom: 20px ;
   
}
.custom-text-color2{
text-indent: 2em !important;
text-align: left;
line-height: 2em;
font-size: 16px;
font-weight:650

}
.custom-text-color3{
  color:gray;
text-indent: 2em !important; 
}
@media  (max-width: 768px) {
span{
  display: block;
}
}

</style>

<style>
section {
  position: relative;
}
</style>
